import React from "react";
import { SiteFooter } from "./SiteFooter";

const renderParagraphs = (paragraphs = []) =>
  paragraphs.map((paragraph) => (
    <p key={paragraph}>{paragraph}</p>
  ));

const renderBullets = (bullets = []) => {
  if (!bullets.length) {
    return null;
  }

  return (
    <ul className="legal-list">
      {bullets.map((bullet) => (
        <li key={bullet}>{bullet}</li>
      ))}
    </ul>
  );
};

export const LegalPageLayout = ({
  title,
  lastUpdated,
  introTitle,
  introParagraphs = [],
  sections = [],
}) => {
  return (
    <>
      <main id="main-content" className="legal-page">
        <div className="container legal-shell">
          <div className="legal-hero">
            <span className="section-kicker">Echo MSG for WhatsApp</span>
            <h1>{title}</h1>
            <p className="legal-updated">Last updated: {lastUpdated}</p>
          </div>

          <article className="legal-card">
            <section className="legal-section legal-section-intro">
              <h2>{introTitle}</h2>
              {renderParagraphs(introParagraphs)}
            </section>

            {sections.map((section) => (
              <section className="legal-section" key={section.title}>
                <h2>{section.title}</h2>
                {renderParagraphs(section.paragraphs)}
                {renderBullets(section.bullets)}
              </section>
            ))}
          </article>
        </div>
      </main>

      <SiteFooter />
    </>
  );
};
